import { useQuery } from '@tanstack/react-query';
import Api from '@/services/api';
import { OWAS_QUERY_KEYS } from '../enums';
import type { BaseContext } from '@/types';

type GetOwasTasksRequest = BaseContext & {
	name?: string;
	limit: number;
	offset: number;
	workstation_id: string;
};

type GetOwasTasksResponse = {
	id: string;
	name: string;
	manual_tools?: string;
};

async function getTasks(params: GetOwasTasksRequest): Promise<GetOwasTasksResponse[]> {
	const url = `/ergonomic-tool/owas/task`;
	const { data } = await Api.get<GetOwasTasksResponse[]>(url, { params });
	return data;
}

export const useGetOWASReportTask = (params: GetOwasTasksRequest) => {
	return useQuery([OWAS_QUERY_KEYS.GET_TASKS, params], () => getTasks(params));
};
